import React, { Component } from 'react';
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavbarToggler,
  Collapse,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavLink,
} from 'reactstrap'
import SVGInline from "react-svg-inline"
import HeaderLink from '../HeaderLink/HeaderLink'

import styles from './PublicHeader.css'
import LogoSVG from '../../assets/img/logo.svg?raw'
import { color_logo_blue } from "../../constants/colors";

export default class PublicHeader extends Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {

    let { scrolled } = this.props;
    const { match, location, history, iframe } = this.props;

    if (
      (match.path === '/'
      && !match.isExact
      && location.pathname !== '/patient'
      && location.pathname !== '/doktor'
      && location.pathname !== '/pricing'
      ) || iframe
    ) {
      scrolled = true;
    }

    return (
      <div className={[styles.header, scrolled ? styles.scrolled : ""].join(' ')}>
        <Navbar className={styles.headerNavbar} color="light" light expand="md">
        { !iframe && 
          <NavbarBrand href="/">
            <div className={styles.logoWrapper}>
              <SVGInline svg={LogoSVG} height="48px" width="246px" />
              <span className={styles.subtitle} style={{ color: color_logo_blue }}>Arzttermine Kurzfristig. Einfach. Schnell.</span>
            </div>
          </NavbarBrand>
          }
          { iframe && 
          <NavbarBrand href="#" onClick={(e) => e.preventDefault()}>
            <div className={styles.logoWrapper}>
              <SVGInline svg={LogoSVG} height="48px" width="246px" />
              <span className={styles.subtitle} style={{ color: color_logo_blue }}>Arzttermine Kurzfristig. Einfach. Schnell.</span>
            </div>
          </NavbarBrand>
          }
          { !iframe && 
            <NavbarToggler className={styles.toggler} onClick={this.toggle} />
          }
          
          { !iframe && 
              <Collapse isOpen={this.state.isOpen} navbar>
              <Nav navbar className={[styles.navbarNav, "ml-auto"].join(' ')}>
                <NavItem>
                  <HeaderLink
                    to="/"
                    label="Home"
                    activeOnlyWhenExact={true}
                  />
                </NavItem>
                <NavItem>
                  <HeaderLink
                    to="/patient"
                    label="Patienten"
                  />
                </NavItem>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle className={styles.dropdownToggle} nav caret>
                    Ärzte
                  </DropdownToggle>
                  <DropdownMenu className={styles.dropdownMenu} right>
                    <DropdownItem>
                      <NavLink href={'/doktor'}>Übersicht</NavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink className={styles.navLink} href={'/pricing'}>Pakete & Preise</NavLink>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <NavItem>
                  <HeaderLink
                    to="/team"
                    label="Team"
                  />
                </NavItem>
                <NavItem>
                  <HeaderLink
                    to="/blog"
                    label="Blog"
                  />
                </NavItem>
                <NavItem>
                  <HeaderLink
                    to="/kontakt"
                    label="Kontakt"
                  />
                </NavItem>
                <NavItem>
                  <HeaderLink
                    to="/dashboard"
                    label="Ärztebereich"
                  />
                </NavItem>
              </Nav>
            </Collapse>
          }
          
          
        </Navbar>
      </div>
    )
  }
}


/*
{match.url.indexOf('iframe/termin') >= 0 && (
            <Collapse isOpen={this.state.isOpen} navbar>
            <Nav navbar className={[styles.navbarNav, "ml-auto"].join(' ')}>
              <NavItem>
                <HeaderLink
                  onClick={(e) => {
                    e.preventDefault();
                    history.goBack();
                  }}
                  noActive={true}
                  activeOnlyWhenExact
                  label="Zurück zur Übersicht"
                />
              </NavItem>
            </Nav>
            </Collapse>
          )}
*/


// WEBPACK FOOTER //
// ./src/components/PublicHeader/PublicHeader.js